import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
import { isText } from "../../Util/Util/validations.js";
const Text = ({ validations = [isText], ...rest }) => /* @__PURE__ */ React.createElement(ConnectedFormControl, { ...ConnectedFormControl.defaultProps, validations, ...rest });
export {
  Text as default
};
//# sourceMappingURL=Text.js.map
